export const IN_PROGRESS_STATUSES = ['generating', 'processing', 'packaging'];
export const FAILURE_STATUSES = ['failed', 'error'];

export const getProjectTimestamp = (project = {}) =>
  project.updatedAt ||
  project.updated_at ||
  project.createdAt ||
  project.created_at ||
  null;

export const formatProjectDate = (dateString, options = {}) => {
  if (!dateString) return 'N/A';

  const date = new Date(dateString);

  if (Number.isNaN(date.getTime())) {
    return 'N/A';
  }

  const { includeTime = false } = options;

  if (includeTime) {
    return `${date.toLocaleDateString()} ${date.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' })}`;
  }

  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
};

export const getProjectModeLabel = (mode) => (
  mode === 'quick' ? 'Quick Theme' : 'Custom Theme'
);

export const getProjectStatusLabel = (status) => {
  if (!status || typeof status !== 'string') return 'Unknown';

  const labels = {
    completed: 'Completed',
    failed: 'Failed',
    error: 'Failed',
    generating: 'Generating',
    processing: 'Processing',
    packaging: 'Packaging',
  };

  return labels[status] || status.charAt(0).toUpperCase() + status.slice(1);
};

export const isProjectReadyToDownload = (project = {}) => (
  project.status === 'completed' && (project.payment_status === 'paid' || project.can_download)
);

export const isProjectPaymentRequired = (project = {}) => (
  project.status === 'completed' && !isProjectReadyToDownload(project)
);

export const getProjectBucket = (project = {}) => {
  if (IN_PROGRESS_STATUSES.includes(project.status)) {
    return 'inProgress';
  }

  if (FAILURE_STATUSES.includes(project.status) || isProjectPaymentRequired(project)) {
    return 'actionNeeded';
  }

  if (isProjectReadyToDownload(project)) {
    return 'completed';
  }

  return 'other';
};

export const getProjectPrimaryAction = (project = {}) => {
  if (isProjectReadyToDownload(project)) {
    return { key: 'download', label: 'Download' };
  }

  if (isProjectPaymentRequired(project)) {
    return { key: 'pay', label: 'Pay & Download' };
  }

  if (IN_PROGRESS_STATUSES.includes(project.status)) {
    return { key: 'resume', label: 'Resume' };
  }

  if (FAILURE_STATUSES.includes(project.status)) {
    return { key: 'view', label: 'View Issue' };
  }

  return { key: 'view', label: 'View' };
};
